<template>
  <div class="BIM-camera-wapper">
    <div class="wapper-title" v-if="changeCameraSize">
      <span>{{clickBIMCarmerName}}</span>
      <i class="safety-icon icon-shrink" @click="changeCamera"></i>
      <!-- <i class="safety-icon icon-close" @click="close"></i> -->
    </div>
    <div class="camera-iframe">
        <iframe 
          class="vjs-custom-skin"
          :src="clickBIMCarmerSrc"
          frameborder="0"></iframe>
    </div>
  </div>
</template>
<script>
export default {
  name: "BIMCamera",
  data() {
    return { 
      changeSize:true,
      playerOptions: {
        height: '',
        autoplay: true,     // 自动播放
        muted: true,
        language: 'en',
        playbackRates: [0.7, 1.0, 1.5, 2.0],  // 倍速
        sources: [{
            type: "video/mp4",
            src: "http://vjs.zencdn.net/v/oceans.mp4",
        }],
        poster: "https://surmon-china.github.io/vue-quill-editor/static/images/surmon-1.jpg",
        
    }
    };
  },
  props: {
    changeCameraSize: {
        type:Boolean,
        required:true
    },
    clickBIMCarmerSrc: {
        type:String,
        required:true
    },
    clickBIMCarmerName: {
        type:String,
        required:true
    },

  },
  mounted() {
    window.addEventListener("resize", this.resizeTheVideo);   
  },
  
  watch: {
      changeCameraSize(val){
          console.log(val,'changeCameraSize')
          if(val){
              console.log('1')
          }else{
              console.log(2)
          }
          
          // val==true? this.playerOptions.height='320':this.playerOptions.height='450'
          this.changeSize = val 
          // window.addEventListener("resize", this.resizeTheVideo);
      },

  },
  methods: {
    close() {
      this.$emit("close");
    },
    changeCamera() {
      this.$emit("changeCamera");
    },
    resizeTheVideo() {
      if (this.$refs && this.$refs.videoPlayer) {
        this.$refs.videoPlayer.resize();
      } 
    },
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.videoPlayer);
  }
};
</script>
<style lang="scss" scoped>
.BIM-camera-wapper {
    width: 100%;
    height: 100%;
  .wapper-title {
    height: 42px;
    line-height: 42px;
    position: relative;
    background: linear-gradient(90deg, rgba(40, 153, 255, 0.2), rgba(57, 68, 121, 0.12));
    span {
      padding-left: 15px;
      font-size: 19px;
      font-family: SourceHanSansCN;
      font-weight: 500;
      color: #26abff;
    }
    .safety-icon {
      cursor: pointer;
      display: inline-block;
      width: 24px;
      height: 24px;
      position: absolute;
      top: 10px;
      background-image: url("../../assets/images/safety/shrink.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
    .icon-shrink {
      right: 10px;
    }
    // .icon-close {
    //   right: 10px;
    //   background-image: url("../../assets/images/safety/close.png");
    // }
  }
  .camera-iframe{
    height: 100%;
    width: 100%;
  }
}

</style>
<style>
 
.BIM-camera-wapper .video-js.vjs-custom-skin .vjs-control-bar {
  height: 90px;
}
.BIM-camera-wapper .video-js.vjs-custom-skin .vjs-control {
    width: 4em!important;
}
.BIM-camera-wapper .video-js .vjs-time-control,.BIM-camera-wapper .video-js.vjs-custom-skin .vjs-control-bar .vjs-playback-rate .vjs-playback-rate-value {
  font-size: 2em!important;
  line-height: 3em!important;
}
.BIM-camera-wapper .video-js .vjs-control:before {
  height: 50px;
  font-size: 4em;
}
.vjs-custom-skin > .video-js .vjs-control-bar .vjs-time-control{
  margin:0 !important; 
  margin-top: -0.8em !important; 
}

.vjs-custom-skin{
  width: 100%;
  height: 100% !important;
}
.vjs-big{ 
  width: 100%;
  height: 620px !important;
}
</style>